import Api from "@/services/Api";
const basePath = "/user/role";
const all = (payload) => {
  const path = `${basePath}/all`;
  const endpoint = payload
    ? `${
        path +
        "?" +
        Object.keys(payload)
          .map((key) => key + "=" + payload[key])
          .join("&")
      }`
    : path;

  return Api.getRequest({
    endpoint,
  });
};

const store = (payload) => {
  return Api.postRequest({
    endpoint: `${basePath}/store`,
    data: payload,
  });
};

const update = (payload) => {
  return Api.postRequest({
    endpoint: `${basePath}/update/${payload.id}`,
    method: "PUT",
    data: payload,
  });
};

export default {
  all,
  store,
  update,
};
